import { DeliveryMode } from '../../../../../services/exports/Constants';

export default {
  sections: {
    state: {
      title: 'Stan',
      fields: {
        delivery_visible: {
          label: 'Dostawa widoczna',
        },
        has_delivery: {
          label: 'Dostawa',
        },
        delivery_enabled: {
          label: 'Dostawa aktywna',
        },
      },
    },
    delivery_mode: {
      title: 'Tryb dostawy',
      fields: {
        delivery_mode: {
          options: {
            [DeliveryMode.Internal]: 'Własna flota kierowców',
            [DeliveryMode.External]: 'Zewnętrzna flota kierowców ({{providers}})',
          },
        },
        external_delivery_pickup_note: {
          label: 'Notatka dla kierowcy przy odbiorze',
          placeholder: 'Dodatkowe informacje dla kierowcy (np. jak znaleźć wejście itp.)',
        },
        instant_print_enabled: {
          label: 'Drukuj bilet bez czekania na kierowcę',
        },
        provider_not_connected: {
          wolt_drive: 'Jeszcze nie połączono: ta restauracja nie ma prawidłowego identyfikatora lokalu Wolt.',
          connects_on_external:
            '{{provider}} zostanie połączony, gdy tryb dostawy zostanie ustawiony na zewnętrznych kierowców i zapisany.',
          not_connected_yet:
            '{{provider}} nie jest jeszcze połączony dla tej restauracji. Jeśli to się nie zmieni, skontaktuj się z pomocą techniczną.',
        },
      },
    },
    scheduled_orders: {
      title: 'Zamówienia zaplanowane',
      fields: {
        has_scheduled_orders: {
          label: 'Czy klienci mogą zamawiać z wyprzedzeniem na określone godziny?',
        },
        min_schedule_ahead_time_delivery: {
          label: 'Minimalny czas (minuty) z wyprzedzeniem przy planowaniu zamówień <strong>z dostawą</strong>',
          placeholder: '60',
          validation_name: 'Minimalny czas planowania dostawy',
          external_hint: 'Przy zewnętrznej dostawie musi wynosić co najmniej {{minutes}} minut (2 godziny). ',
        },
        last_order_gap_delivery: {
          label: 'Ostatni możliwy czas zamówienia <strong>z dostawą</strong> (minuty przed zamknięciem)',
          option: '{{value}} min',
        },
      },
    },
    delivery_info: {
      title: 'Informacje o dostawie',
      fields: {
        average_order_delivery_time_min: {
          label: 'Czas dostawy',
          placeholder: 'Czas w minutach',
        },
        average_order_delivery_time_max: {
          label: 'do',
          placeholder: 'Opcjonalnie',
        },
      },
    },
    delivery_zones: {
      title: 'Strefy dostaw',
    },
  },
  buttons: {
    save: 'Zapisz',
  },
  toasts: {
    at_least_one_order_method_required:
      'Co najmniej 1 metoda zamówienia (zaplanowane lub natychmiast) musi być włączona. Nie można wyłączyć obu.',
  },
};
